import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem("sugandhi_cart");
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });
  const [isOpen, setIsOpen] = useState(false);
  const [coupon, setCoupon] = useState(null); // { code, discount_percent, discount_amount }

  useEffect(() => {
    localStorage.setItem("sugandhi_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems(prev => {
      const existing = prev.find(i => i.id === product.id);
      if (existing) {
        return prev.map(i => i.id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        id: product.id, slug: product.slug, name: product.name,
        price: product.price, image: product.images?.[0] || "",
        quantity: qty,
      }];
    });
  };

  const updateQty = (id, qty) => {
    setItems(prev => qty <= 0
      ? prev.filter(i => i.id !== id)
      : prev.map(i => i.id === id ? { ...i, quantity: qty } : i));
  };

  const removeItem = (id) => setItems(prev => prev.filter(i => i.id !== id));
  const clear = () => { setItems([]); setCoupon(null); };

  const subtotal = useMemo(() =>
    items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const discount = coupon?.discount_amount || 0;
  const total = Math.max(0, subtotal - discount);
  const itemCount = items.reduce((n, i) => n + i.quantity, 0);

  return (
    <CartContext.Provider value={{
      items, itemCount, subtotal, discount, total,
      isOpen, setIsOpen,
      addItem, updateQty, removeItem, clear,
      coupon, setCoupon,
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
